export const analystsMessage = `Which of the following best describes your enterprise’s population of analytics 
professionals (analytsts, data scientists, etc.)?`;

const analystsQ1 = `Few skills, and those are attached to specific functions.`;

const analystsQ2 = `Disconnected pockets of analysts; unmanaged mix of skills.`;

const analystsQ3 = `Analysts recognized as key talent and focused on important business areas.`;

const analystsQ4 = `Highly capable analysts explicitly recruited, deployed and engaged.`;

const analystsQ5 = `World-class professional analysts; cultivation of analytical amateurs across the enterprise.`;

export const analystsQuestions = [ analystsQ1, analystsQ2, analystsQ3, analystsQ4, analystsQ5 ];
export const analystsQuestionWeight = 0.16;
export const analystsQuestionsScore = [ 0.16, 0.32, 0.48, 0.64, 0.80 ];


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/delta/data/analystsQuestions.ts